
import TitleService from 'title-service';
import './ProfileListTItle.scss';
export default function ProfileListTItle(props: any) {
    return (
        <h2 className="padding--bottom-6 text-color--primary ">{TitleService("Who's Watching?")}</h2>
    );
}